import { render, staticRenderFns } from "./QueueInfo.vue?vue&type=template&id=42ca270a&scoped=true&lang=pug"
import script from "./QueueInfo.vue?vue&type=script&lang=js"
export * from "./QueueInfo.vue?vue&type=script&lang=js"
import style0 from "./QueueInfo.vue?vue&type=style&index=0&id=42ca270a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca270a",
  null
  
)

export default component.exports